export default __webpack_public_path__ + "static/media/B78.d6c7cdd5.png";